module.exports = __webpack_public_path__ + "img/followDoc_b.e983def0.png";